import styles from "./Info.module.css";
import homeDetailsImg from "../../assets/images/home-details.png";

const Info = () => {
  return (
    <section className={styles.section}>
      <img className={styles.img} src={homeDetailsImg} alt="Football Ground" />
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
          <p className={styles.content}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
            dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
            modi?
          </p>
        </div>
      </div>
    </section>
  );
};

export default Info;
